import React from 'react';
import { Carousel, Image } from '../components';
import './Logos.scss';

export const Logos = props => {
  const { data } = props;
  const { primary, items = [] } = data;
  const { title } = primary;
  const carouselResponsive = {
    0: { items: 2 },
    500: { items: 3 },
    660: { items: 4 },
    769: { items: 6 },
  };

  return (
    <section className="logos">
      <div className="wrapper">
        {title && title.text && <h4 className="logos-title">{title.text}</h4>}
        <Carousel
          containerClassName="logos-body"
          responsive={carouselResponsive}
          enabledBetween={items.length <= 6 ? [0, 750] : [0, 9999]}
          buttonsDisabled
          infinite
        >
          {items.map((logo, index) => (
            <div className="logos-body-logo" key={index}>
              <Image image={logo.logo} />
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
};
